"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectProps = void 0;

var _react = require("react");

var injectProps = function injectProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      activeIndex = _ref.activeIndex,
      handleChange = _ref.handleChange,
      onTabChange = _ref.onTabChange;

  return function (child, index) {
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      index: index,
      isActive: activeIndex === index,
      onTabClick: function onTabClick() {
        handleChange(index);
        onTabChange(index);
      }
    });
  };
};

exports.injectProps = injectProps;